<template>
  <div>
    <v-row>
      <v-col offset-md="2" cols="12" md="8">
        <h1 class="text-left ml-2">Institution Details</h1>
      </v-col>
    </v-row>

    <v-form v-model="form" @submit.prevent="submitInstitutionDetails" v-if="institutionDetails">
      <v-container fluid>
        <v-row>
          <v-col offset="3" cols="3">
            <v-avatar width="100" height="100">
              <v-img
                :src="getUrl(institutionDetails.logo)"
              />
            </v-avatar>
          </v-col>

          <v-col cols="3">
            <v-file-input class="mt-4" @change="institutionImageCallback" accept="image/*" label="Logo Image"></v-file-input>
          </v-col>

          <v-col offset-md="2" cols="12" md="8">
            <v-text-field
              v-model="institutionDetails.name"
              :rules="[rules.required]"
              outlined
              label="Name"
              class="rounded-input"
              hide-details="auto"
              maxlength="55"
            >
              <template #label>
                Name<span class="red--text"><strong> *</strong></span>
              </template>
            </v-text-field>
          </v-col>

          <v-col offset-md="2" cols="12" md="2">
            <v-text-field
              v-model="institutionDetails.location"
              :rules="[rules.required]"
              outlined
              class="rounded-input"
              hide-details="auto"
              maxlength="55"
            >
              <template #label>
                Location<span class="red--text"><strong> *</strong></span>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="institutionDetails.address"
              outlined
              label="Address"
              class="rounded-input"
              hide-details="auto"
              maxlength="55"
            ></v-text-field>
          </v-col>

          <v-col offset-md="2" cols="12" md="2">
            <v-text-field
              v-model="institutionDetails.code"
              :rules="[rules.required]"
              outlined
              disabled
              class="rounded-input"
              hide-details="auto"
              maxlength="55"
            >
              <template #label>
                Institution Code<span class="red--text"><strong> *</strong></span>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="institutionDetails.website"
              outlined
              label="Website"
              class="rounded-input"
              hide-details="auto"
              maxlength="55"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row justify="center" class="my-1">
          <v-col cols="12" md="8" align-self="center">
            <h2 class="my-1">
              Select Modules
            </h2>
            <SelectModules
              @updateSelectedModules="updateSelectedModules"
            />
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="3" align-self="center">
            <v-btn type="submit" color="primary" block :disabled="isLoading || !form">Submit</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-snackbar :color="snackbar.color" v-model="snackbar.visible">
      <span>{{ snackbar.text }}</span>
      <template>
        <v-btn color="white" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import Helper from "@utils/misc";
import SelectModules from "@components/onboarding/SelectModules.vue"

export default {
  name: "InstitutionDetailSettings",

  components: {
    SelectModules
  },

  data() {
    return {
      institutionDetails: {
        code: null,
        name: null,
        location: null,
        address: null,
        website: null,
        logo: null,
        erp_features: []
      },

      form: false,

      snackbar: {
        visible: false,
        text: "",
        color: ""
      },

      rules: {
        required: (v) => !!v || "This field is required",
        code: (v) => /^[a-zA-Z0-9]{1,4}$/.test(v) || "Invalid",
      },

      selectedModules: [],
    };
  },
  computed: {
    ...mapGetters(["isLoading", "accessToken", "currentUser", "currentInstitution"]),

    apiEssentials() {
      return {
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
        setLoading: this.setLoading,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        this.snackbar.text = "Unable to process request";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
        
      } else {
        this.snackbar.text = "Unable to process request";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },
    
    getUrl(image) {
      try{
        return URL.createObjectURL(image);        
      } 
      catch(_){
        return image;
      }
    },

    // executed when student image is added
    async institutionImageCallback(image) {
      if (!image) {
        this.institutionDetails.logo = null;
      }
      this.institutionDetails.logo = await Helper.toBase64(image);
    },

    async getInstitutionDetails() {
      this.institutionDetails = await api.call(
        this.apiEssentials,
        endpoints.institutionsViewSet + this.currentInstitution.id + "/"
      );
    },

    // update currentInsti details in store
    async updateCurrentInstitutionDetails() {
      if(this.currentInstitution){
        var response;
        response = await api.handleApi({
          apiEssentials: this.essentials,
          url:
            endpoints.getInstitutionDetailsById +
            (this.currentInstitution ? this.currentInstitution.id : 0 )+
            "/",
          responseVar: response,
        });

        if (response != null) {
          this.setCurrentInstitution(response);
        }
      }
    },

    async submitInstitutionDetails() {
      var response = await api.call(this.apiEssentials, endpoints.institutionsViewSet + this.currentInstitution.id + '/', api.Methods.PUT, this.institutionDetails); 
      if(response){
        this.updateCurrentInstitutionDetails()
        this.snackbar.text = "Institution Details were successfully saved";
        this.snackbar.color = "green";
        this.snackbar.visible = true;
        setTimeout(() => window.location.reload(), 1000);
      }
    },

    updateSelectedModules(modules) {
      if(modules) {
        this.selectedModules = modules
        this.institutionDetails.erp_features = `[${this.selectedModules}]`
      }
    },
  },
  created() {
    this.getInstitutionDetails();
  },
};
</script>